module.exports = __webpack_public_path__ + "img/made-project-detail-3.jpg";